import { Injectable } from '@angular/core';

import { TRelatedPoint, TRelatedPointPayload } from './related-points.consts';

@Injectable({
  providedIn: 'root',
})
export class RelatedPointsCacheService {
  private pendingRelationships: Record<string, TRelatedPoint[]> = {};

  addPendingRelationship(pointId: string, relation: TRelatedPoint): void {
    const current = this.pendingRelationships[pointId] ?? [];
    this.pendingRelationships[pointId] = [...current, relation];
  }

  removePendingRelationship(pointId: string, relatedPointId: string): void {
    const current = this.pendingRelationships[pointId];

    if (!current) {
      return;
    }

    this.pendingRelationships[pointId] = current.filter(
      (relation) => relation.pointId !== relatedPointId,
    );
  }

  getPendingRelationships(pointId: string): TRelatedPointPayload[] {
    const relations = this.pendingRelationships[pointId] ?? [];

    return relations.map((relation) => ({
      type: relation.type,
      relatedPointId: relation.pointId,
    }));
  }

  clearPendingRelationships(pointId: string): void {
    delete this.pendingRelationships[pointId];
  }
}
